import { Injectable } from '@angular/core';

import { ClientConfig, ClientConfigProductName, ClientConfigService } from '@frontend/vanilla/core';

@ClientConfig({
    key: 'bmaUserInterfaceConfig',
    product: ClientConfigProductName.OZONE,
    reload: false,
} as any)
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService],
    useFactory: userConfigFactory,
})
export class UserInterfaceClientConfig {
    rtsLink: string;
    cashierUrl: string;
    accountUpgradeLink: {
        imc: string;
        omc: string;
    };
    cspSegmentExpiry: number;
    homeBiometric: {
        android: boolean;
        ios: boolean;
    };
}
export function userConfigFactory(service: ClientConfigService) {
    return service.get(UserInterfaceClientConfig);
}
